import React from "react";
import styles from "./headwithSubhead.module.css";
import { Col, Row } from "react-bootstrap";

const HeadWithSubHead = ({ head, subHead }) => {
  return (
    <>
      <Row className={styles.containerbox}>
        <Col>
          <p className={styles.Heading}>{head}</p>
          <p className={styles.subHeading}>{subHead}</p>
        </Col>
      </Row>
      {/* <h1 className={styles.Heading}>{head}</h1>
        <p className={styles.subHeading}>{subHead}</p> */}
    </>
  );
};

export default HeadWithSubHead;
